import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Icon from 'react-web-vector-icons';
import PopupButton from "../PopupButton";

import './ConfirmBox.scss';

export const showConfirm = ({
	title,
	message,
	onConfirm,
	confirmButtonLabel = 'Yes',
	confirmButtonType = 'primary', // Kept for backward compatibility but will be overridden
	confirmButtonIconRight = null,
	onCancel,
	cancelButtonLabel = 'Cancel',
	cancelButtonType = 'secondary' // Kept for backward compatibility but will be overridden
}) => {
	confirmAlert({
		customUI: ({ onClose }) => {
			return (
				<div className="confirm-box-container">
					<div className="confirm-box-header">
						<div className="confirm-box-title">{title}</div>
						<div
							className="popup-close-btn"
							onClick={() => {
								onCancel && onCancel();
								onClose();
							}}
						>
							<Icon name="close" font="AntDesign" size={12} />
						</div>
					</div>

					<div className="confirm-box-content">
						<p className="confirm-box-message" dangerouslySetInnerHTML={{ __html: message }}></p>
					</div>

					<div className="confirm-box-footer">
						<PopupButton
							variant="secondary"
							onClick={() => {
								onCancel && onCancel();
								onClose();
							}}
						>
							{cancelButtonLabel}
						</PopupButton>
						<PopupButton
							variant={confirmButtonType}
							rightIcon={confirmButtonIconRight}
							onClick={() => {
								onClose();
								onConfirm();
							}}
						>
							{confirmButtonLabel}
						</PopupButton>
					</div>
				</div>
			);
		}
	});
};
